import { useState } from "react";
import { Plus } from "lucide-react";
import { inr, today, useCan, useLoad } from "@/lib/api";
import { ErrorBox, PageHeading } from "@/components/common";
import TransactionForm from "@/components/forms/TransactionForm";
import { TransactionList } from "@/components/ledgerLists";

export default function Payments() {
  const can = useCan();
  const [show, setShow] = useState(false);
  const [day, setDay] = useState(today());
  const [all, setAll] = useState(false);
  const list = useLoad(all ? "/payments" : `/payments?day=${day}`, []);
  const summary = useLoad(`/ledger/summary?day=${day}`, {});
  const refresh = () => { setShow(false); list.reload(); summary.reload(); };
  const s = summary.data;
  const cards = [["Collected", s.collected, "summary-collected"], ["Refunded", s.refunded, "summary-refunded"], ["Discounts", s.discounted, "summary-discounted"], ["Net collection", s.net_collection, "summary-net"], ["All outstanding", s.total_outstanding, "summary-outstanding"], ["Advances in credit", s.total_advance_credit, "summary-advance"]];
  return (
    <div className="content">
      <PageHeading eyebrow="PATIENT PAYMENTS" title="Money in," accent="never counted twice." sub="Advances are payments. Discounts reduce what is owed; refunds add it back.">
        {can("payments:write") && <button className="primary" onClick={() => setShow(true)} data-testid="add-transaction-button"><Plus size={18} /> Record transaction</button>}
      </PageHeading>
      <section className="summary-grid">{cards.map(([l, v, tid]) => <div className="mini-stat" key={l}><span>{l}</span><b data-testid={tid}>{inr(v)}</b></div>)}</section>
      <div className="toolbar">
        <div className="chips">
          <input type="date" className="date-input" value={day} onChange={(e) => { setDay(e.target.value); setAll(false); }} data-testid="payments-day-input" />
          <button className={all ? "chip active" : "chip"} onClick={() => setAll(!all)} data-testid="payments-show-all-toggle">{all ? "Showing all dates" : "Show all dates"}</button>
        </div>
        <span className="result-count" data-testid="transaction-count">{list.data.length} entries</span>
      </div>
      <ErrorBox error={list.error} testid="payments-error" />
      <TransactionList rows={list.data} onChanged={refresh} />
      {show && <TransactionForm onClose={() => setShow(false)} onSaved={refresh} />}
    </div>
  );
}
